export class Absence {
  id?: string = undefined
  absentSince?: string = undefined
  absentUntil?: string = undefined

  constructor(data: Partial<Absence> = {}) {
    Object.assign(this, data)
  }
}